(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["le-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('le-review-slider')) {
    customElements.define('le-review-slider', class extends HTMLElement {
      connectedCallback() {
        const track = this.querySelector('[data-track]');
        const dotsWrap = this.querySelector('[data-dots]');
        if (!track || !dotsWrap) return;
        const cards = () => [...track.children];
        const offset = (c) => c.offsetLeft - track.firstElementChild.offsetLeft;
        const mark = () => {
          const list = cards();
          let active = 0;
          const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
          if (atEnd) {
            active = list.length - 1;
          } else {
            let best = Infinity;
            list.forEach((c, n) => {
              const d = Math.abs(offset(c) - track.scrollLeft);
              if (d < best) { best = d; active = n; }
            });
          }
          [...dotsWrap.children].forEach((d, n) => d.classList.toggle('is-active', n === active));
        };
        const build = () => {
          dotsWrap.innerHTML = '';
          const list = cards();
          if (list.length < 2 || track.scrollWidth <= track.clientWidth + 4) return;
          list.forEach((c, n) => {
            const d = document.createElement('button');
            d.type = 'button';
            d.className = 'le-dot';
            d.setAttribute('aria-label', 'Avis ' + (n + 1));
            d.addEventListener('click', () => track.scrollTo({ left: offset(c), behavior: 'smooth' }));
            dotsWrap.appendChild(d);
          });
          mark();
        };
        track.addEventListener('scroll', () => requestAnimationFrame(mark), { passive: true });
        window.addEventListener('resize', build);
        build();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
